import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOrganizerPortal } from '../../contexts/OrganizerPortalContext';

/**
 * Laesst nur durch, wer mit mindestens einem Veranstalter verknuepft ist.
 *
 * Bewusst getrennt von `ProtectedRoute`: das rechnet mit einem linearen Rollenrang
 * (USER &lt; MODERATOR &lt; ADMIN), und „ist Veranstalter" passt da nicht hinein — ein Admin kann
 * gleichzeitig Veranstalter sein, ein Veranstalter ist kein halber Moderator. `ProtectedRoute`
 * prueft weiterhin nur die Anmeldung, diese Huelle die Verknuepfung.
 */
const RequireOrganizer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isOrganizer, loading } = useOrganizerPortal();

  if (loading) {
    return (
      <div className="p-10 text-sm" style={{ color: 'var(--text-muted)' }}>
        Wird geladen…
      </div>
    );
  }
  if (!isOrganizer) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};

export default RequireOrganizer;
